import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=72cc394a&scoped=true"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"
import style0 from "./blank.vue?vue&type=style&index=0&id=72cc394a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc394a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72cc394a')) {
      api.createRecord('72cc394a', component.options)
    } else {
      api.reload('72cc394a', component.options)
    }
    module.hot.accept("./blank.vue?vue&type=template&id=72cc394a&scoped=true", function () {
      api.rerender('72cc394a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/blank.vue"
export default component.exports